import { defineComponent as _defineComponent } from 'vue'
import {computed} from 'vue';
import {useFormNavigation} from '@/components/calculator/form/useSimulationForm';
import {useSimulationStore} from '@/components/calculator/services/SimulationStore';
import {useCalculatorVersion} from '@/components/calculator/useCalculatorVersion';
import {useSimulationHorizontalNavigation} from '@/modules/calculator-v25/composables/shared/results/useSimulationHorizontalNavigation';
import {useMortgageRealEstatesStore} from '@/modules/calculator-v25/services/mortgage/MortgageRealEstatesStore';
import {Routes} from '@/router/Routes';
import {ProductType} from '@/commons/enums/ProductType';
import SimulationToolbarZoom from '@/components/calculator/results/toolbar/SimulationToolbarZoom.vue';
import ComparatorFeedback from '@/components/calculator/results/feedback/ComparatorFeedback.vue';
import Deal from '@/models/Deal';
import SimulationDealPicker from '@/components/calculator/results/SimulationDealPicker.vue';
import { useNewDealModal } from '@/composables/useNewDealModal';
import { useInstance } from '@/composables/useInstance';
import {i18nFormatter} from '@/services/StringFormatter';
import AuthService from '@/modules/user/AuthService';
import { hasAccessToNewDealFlow } from '@/modules/user/services/Utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'CalculatorNavigation',
  setup(__props) {

const store = useSimulationStore();
const realEstatesStore = useMortgageRealEstatesStore();
const {goBackToForm,} = useFormNavigation();
const {isNewMortgageComparator,} = useCalculatorVersion();
const {isNavigationZoomRendered, navigationZoomClass,} = useSimulationHorizontalNavigation();
const { $user, $modalService, $route, $snackbarService, $i18n, } = useInstance();
const t = $i18n.useCalculatorNavigationComponent;
const tDealPicker = $i18n.useDealPicker;

const stagingDBMode = computed<boolean>({
  get: () => Boolean(store.userInput?.stagingDBMode),
  set: value => {
    if (!store.userInput) {
      return;
    }
    store.userInput.stagingDBMode = value;
  },
});
const newCalculatorSummaryRoutes: string[] = Object.values(ProductType)
  .map(productType => Routes.NEW_CALCULATOR.SUMMARY(productType));
const isSummaryRoute = computed<boolean>(() => newCalculatorSummaryRoutes.includes($route.value.name ?? ''));

const onStagingDBModeChange = async() => {
  await store.createOrUpdateSimulation();
};

const openLoadDealModal = async() => {
  if (hasAccessToNewDealFlow(AuthService.User)) {
    const { openNewDealModal, } = useNewDealModal($modalService);
    const response = await openNewDealModal(undefined, {
      flowTitle: tDealPicker.LOAD_DEAL,
      mode: 'LoadDeal',
      simulationId: store.simulationId || undefined,
      modeProductType: store.productType,
    });

    if (response?.deal) {
      await store.init(store.productType!, store.simulationId, response.deal);
      $snackbarService.openSuccessSnackbar(
        tDealPicker.DEAL_LOADED
      );
    }
    return;
  }

  const deal = await $modalService.open<Deal>(SimulationDealPicker, {
    productType: store.productType,
    simulationId: store.simulationId,
  }) ?? null;
  if (deal) {
    await store.init(store.productType!, deal?.simulationId, deal);
  }
};

const clear = async() => {
  const response = await $modalService.openConfirmModal({
    description: store.deal?.name ? i18nFormatter(
      t.NEW_TRANSLATION_CLEAR_FORM_DESCRIPTION_DEAL,
      {dealName: store.deal?.name,})
      : t.NEW_TRANSLATION_CLEAR_FORM_DESCRIPTION_NO_DEAL,
    title: t.CLEAR_FORM_TITLE,
  }, t.CANCEL, t.CLEAR);
  if (response) {
    realEstatesStore.clear();
    await store.clear();
    await store.createOrUpdateSimulation();
    $snackbarService.openSuccessSnackbar(
      t.CLEAR_SUCCESS
    );
  }
};

return { __sfc: true,store, realEstatesStore, goBackToForm, isNewMortgageComparator, isNavigationZoomRendered, navigationZoomClass, $user, $modalService, $route, $snackbarService, $i18n, t, tDealPicker, stagingDBMode, newCalculatorSummaryRoutes, isSummaryRoute, onStagingDBModeChange, openLoadDealModal, clear, SimulationToolbarZoom, ComparatorFeedback }
}

})